import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

export const DropDown = props => {
  return (
    <FormControl>
      {!!props.label && <InputLabel>{props.label}</InputLabel>}
      <Select {...props}>
        {props.options.map((o, i) => <MenuItem key={i} value={o.id}>{o.name}</MenuItem>)}
      </Select>
    </FormControl>
  )
}